// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__381Bn","dropZone":"App_dropZone__1DAzM","headerText":"App_headerText__2y_nj","subText":"App_subText__E-8bs","breedText":"App_breedText__3Qaff"};